import config from '../config';
import http from '../utils/http';

const { api } = config;

/**
 * Get tenants.
 *
 * @return {Object}
 */
export async function fetchTenants() {
    const url = api.endpoints.tenants;

    const response = await http.get(url);

    return response;
}

/**
 * Set default tenant.
 *
 * @return {Object}
 */
export async function setDefaultTenant(tenantId) {
    const url = `${api.endpoints.tenants}/${tenantId}/default`;

    const response = await http.put(url);

    return response;
}

/**
 * Archive tenant.
 *
 * @return {Object}
 */
export async function archiveTenant(userId) {
    const url = `${api.endpoints.users}/${userId}`;

    const response = await http.delete(url);

    return response;
}

/**
 * Set default tenant.
 *
 * @return {Object}
 */
export async function updateName(tenantId, data) {
    const url = `${api.endpoints.auth}/tenant`;

    const response = await http.put(url, data);

    return response;
}

/**
 * Set default tenant.
 *
 * @return {Object}
 */
export async function createTenant(tenantId, data) {
    const url = api.endpoints.tenants;

    const response = await http.post(url, data);

    return response;
}
